import { useEffect, useState } from 'react';

export function useGetElementRects({ elementRef = null, dependency = [] }) {
  const [itemContainerLayoutChange, setItemContainerLayoutChange] = useState({
    elementRect: {
      scrollWidth: 0,
      clientWidth: 0,
      clientHeight: 0,
    },
    timeChanged: 0,
  });

  useEffect(() => {
    if (elementRef) {
      setItemContainerLayoutChange({
        elementRect: {
          scrollWidth: elementRef.scrollWidth,
          clientWidth: elementRef.clientWidth,
          clientHeight: elementRef.clientHeight,
        },
        timeChanged: Date.now(),
      });
      const resizeObserverInst = new ResizeObserver(() => {
        const { clientWidth, scrollWidth, clientHeight } = elementRef || {};

        setItemContainerLayoutChange({
          elementRect: {
            scrollWidth,
            clientWidth,
            clientHeight,
          },
          timeChanged: Date.now(),
        });
      });

      elementRef && resizeObserverInst.observe(elementRef);
      return () => elementRef && resizeObserverInst.unobserve(elementRef);
    }
  }, [elementRef, ...dependency]);

  return [itemContainerLayoutChange];
}
